// Uncomment in the production
export const AXED_API_CONFIG = {
	baseURL: process.env.REACT_APP_AXED_API_BASE_URL,
};
